import { StoreCheckOutlineIcon } from './StoreCheckOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 35E8862F-A95A-4B1E-AD0A-FAD4C408D4F6
 * name store-check-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-check-outline.svg
 * tags
 * - Shopping 
 * - Places 
 */
export const StoreCompleteOutlineIcon = StoreCheckOutlineIcon;
export default StoreCompleteOutlineIcon